// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo-banner[data-v-66c2b3d2]{width:100%;height:19.1em;background:linear-gradient(278deg,#737886,#686d7a 17%,#3f434e);display:flex;align-items:center}.logo-banner .logo-banner-logo[data-v-66c2b3d2]{width:20.5em}.logo-banner .cancel-btn[data-v-66c2b3d2]{position:absolute;left:20px;color:#8a97a4;text-decoration:none}.logo-banner.mobile[data-v-66c2b3d2]{background:#3f434e;height:64px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
